module.exports = __webpack_public_path__ + "img/log-out.0c870c79.svg";